export const Logo = '/images/header_h1.png'
export const MobileLogo = '/images/header_h1.png'
export const NavWrapper = '/images/nav_back.png'
export const NavBtnWrapper = '/images/nav_btn_back.png'
